import { EncumbrancesExcelModalContextType } from '../types/EncumbrancesExcelModalContextType';

export const INITIAL_ENCUMBRANCES_IMPORT_PROGRESS = {
  total: 0,
  processed: 0,
  created: 0,
  failed: 0,
};

export const encumbrancesExcelModalInitValue: EncumbrancesExcelModalContextType =
  {
    data: {
      step: 'upload',
      excelPreview: null,
      excelFile: undefined,
      isLoading: false,
      isParsingExcel: false,
      uploadInformationalWithErrors: false,
      importProgress: INITIAL_ENCUMBRANCES_IMPORT_PROGRESS,
    },
    actions: {
      handleCloseModal: () => {},
      handleChangeExcelFile: async () => {},
      handleDownloadExcelTemplate: () => {},
      handleBackToUpload: () => {},
      handleToggleUploadInformationalWithErrors: () => {},
      handleImport: async () => {},
    },
  };
